import styled, { css } from "styled-components";

const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  & th {
    background: ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.primary};
    position: sticky;
    top: 0;
    z-index: 4;
  }
  & th,
  & td {
    padding: 0.5rem;
    text-align: left;
    font-size: 0.8rem;
  }

  & td {
    border-bottom: 1px solid
      ${({ theme, darker }) => theme.colors[darker ? "white" : "lightestGrey"]};
  }

  & tbody tr {
    :nth-child(even) {
      & td {
        background: ${({ theme, darker }) =>
          theme.colors[darker ? "white" : "lightestGrey"]};
      }
    }
  }

  & tbody tr.selected {
    td {
      background: #d3d3d3;
    }
  }

  ${({ small }) =>
    small &&
    css`
      & td {
        font-size: 0.65rem;
      }
      & th {
        font-size: 0.75rem;
      }
      & th,
      & td {
        padding: 0.2rem;
      }
    `}
`;

export { Table };
